import './App.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@app/app-routes';
import { rootEl } from './ui/utils/dom/root-el';
import { GoogleOAuthProvider } from '@react-oauth/google';
const app = (
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </GoogleOAuthProvider>
);

createRoot(rootEl).render(app);
